import api from "./index";

export async function createOrder(body) {
  return api.post("/orders", body);
}

export async function getOrder(orderID) {
  return api.get(`/orders/${orderID}`);
}
